export const legacyPdpHeaderFragment = `
  fragment legacyPdpHeaderFragment on PdpPageHeaderRecord {
    button { ...buttonFragment }
    description {
      blocks {
        ... on ListWithIconsBlockRecord { ...listWithIconsFragment }
      }
      links
      value
    }
    image {
      _updatedAt
      responsiveImage(
        imgixParams: {
          auto: format
          cornerRadius: "8"
          fit: crop
          h: 310
          mask: corners
          w: 548
        }
      ) { ...responsiveImageFragment }
    }
    subtitle
    tag
    title
    video {
      _updatedAt
      ...cmsVideoFragment
    }
    ironform {
      ironformId
      ironformType
    }
  }
`;
